<template>
  <q-dialog title="商品销售价调整记录" width="80%" :visible.sync="dialogVisible" :innerScroll="false" :showFooter="false" @close="handleClose">
    <el-form class="dialog-el-form" size="mini">
      <el-form-item label="商品编码(SKU)：" label-width="164px">
        <div style="width: 100%">{{ recordInfo.skuCode }}</div>
      </el-form-item>
      <el-form-item label="商品名称(SKU)：" label-width="164px">
        <div style="width: 100%">{{ recordInfo.skuName }}</div>
      </el-form-item>
    </el-form>
    <el-container class="list-wrapper">
      <el-main class="table-wrap">
        <el-table
          :data="recordTableData.list"
          :header-cell-style="{ backgroundColor: '#F4F8FB' }"
          style="width: 100%"
          border
          height="300"
          v-loading="loading"
          element-loading-text="数据加载中"
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column
            :show-overflow-tooltip="true"
            prop="promotionPriceA"
            label="S级活动到手价"
            width="120"
            v-if="tablePropl.includes('promotionPriceA')"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="promotionPriceB"
            label="A级活动到手价"
            width="120"
            v-if="tablePropl.includes('promotionPriceB')"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="promotionPriceC"
            label="日常活动到手价"
            width="120"
            v-if="tablePropl.includes('promotionPriceC')"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="dailyRetailPrice"
            label="A类价"
            width="60"
            v-if="tablePropl.includes('dailyRetailPrice')"
          ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="tagPrice" label="产品标价(划线价)" v-if="tablePropl.includes('tagPrice')" width="95"></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="clearancePrice"
            label="清仓销售价"
            width="95"
            v-if="tablePropl.includes('clearancePrice')"
          ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="actualExecPrice" label="商品实际执行价格" width="140"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="redEnvelopeOne" label="一段红包" width="80"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="redEnvelopeTwo" label="二段红包" width="80"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="redEnvelopeThree" label="三段红包" width="80"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="liveVerifyPrice" label="达播核价" width="80"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="liveCommission" label="达播佣金" width="80"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="liveControlPrice" label="达播控价" width="80"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="validityDateSection" label="有效期" width="160"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="adjustmentCause" label="调整原因"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="updateBy" label="更新人"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="updateDate" label="更新时间" width="160"></el-table-column>
        </el-table>
      </el-main>
      <el-footer height="64px" style="text-align: right; padding-top: 15px">
        <el-pagination
          @size-change="recordOnSizeChange"
          @current-change="recordOnCurrentChange"
          :current-page="recordTableData.pageNum"
          :page-sizes="[10, 30]"
          :page-size="recordTableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="recordTableData.total"
        ></el-pagination>
      </el-footer>
    </el-container>
  </q-dialog>
</template>

<script>
import axios from '@/utils/axiosInstance';

export default {
  name: 'AdjustmentRecord',
  props: {
    tablePropl: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      recordTableData: {
        list: [],
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      recordInfo: {
        skuCode: '',
        skuName: '',
      },
    };
  },
  mounted() {
    this.dialogVisible = this.visible;
    if (this.row) {
      this.recordInfo.skuCode = this.row.goodsCode;
      this.recordInfo.skuName = this.row.goodsName;
      this.recordTableData.pageNum = 1;
      this.recordOnSearch();
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.$emit('update:visible', false);
    },
    recordOnSizeChange(pageSize) {
      this.recordTableData.pageSize = pageSize;
      this.recordTableData.pageNum = 1;
      this.recordOnSearch();
    },
    recordOnCurrentChange(pageNum) {
      this.recordTableData.pageNum = pageNum;
      this.recordOnSearch();
    },
    recordOnSearch() {
      this.loading = true;
      let data = {
        pageSize: this.recordTableData.pageSize,
        pageNum: this.recordTableData.pageNum,
        reportCode: 'goodsPriceAdjustmentLog',
        queryMatch: [
          {
            attributeName: 'goodsCode',
            val: this.recordInfo.skuCode,
            op: '=',
          },
        ],
        hasCount: 'Y',
      };
      axios.post(`/ec-pc-api/custom/reports/data/goodsPriceAdjustmentLog`, data).then((res) => {
        if (res.code == 200) {
          this.recordTableData = res.data;
        }
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.dialog-el-form
  margin-bottom 10px
.list-wrapper
  padding 0
.table-wrap
  padding 0
</style>
